import React from "react";

import * as S from "./NotAuthLayout.styles";

export const NotAuthLayout = ({ children }) => (
  <S.LayoutContainer>{children}</S.LayoutContainer>
);
